export enum EPoolType {
  Flexible,
  Standard,
  Ferrum,
}
